<script>
    import { Pie } from 'vue-chartjs'

    export default {
        extends: Pie,
        props: {
            chartdata: Array,
            options: Array,
            dataname: String,
            piecolor: Array,
            chartOptions: {
                default: () => ({
                    showAllTooltips: false
                })
            },
            displayLabels: Boolean
        },
        mounted () {
            Chart.defaults.global.legend.display = true

            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: this.piecolor,
                        data: this.options,
                        // Change options only for labels of THIS DATASET
                        datalabels: {
                            display: !!this.displayLabels,
                        },
                    }
                ]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                showAllTooltips: true
            })
        }
    }
</script>

<style scoped>



</style>
